import React, { useState, useEffect } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
// Import local images
import emmanPhoto from '../../assets/asia.jpg';
import patiencePhoto from '../../assets/blackwoman.jpg';
import glennPhoto from '../../assets/danzull001c.jpg';

const testimonials = [
  {
    name: "Emman C.",
    title: "Supply Chain Manager",
    rating: 5,
    text: "EAP Finance has been instrumental in propelling our business forward. Their savvy approach to capital raising and robust investor relationships enabled us to tap into vital funding, driving strategic initiatives and ambitious growth plans. With EAP Finance's guidance, we've navigated complex financial landscapes with confidence and precision.",
    photo: emmanPhoto
  },
  {
    name: "Patience F.",
    title: "Operations Director",
    rating: 5,
    text: "Breaking through the capital ceiling was a game-changer for our business, and EAP Finance made it happen. With their expert guidance and network, we tapped into funding opportunities that transformed our growth trajectory. Today, we're not just funded – we're future-ready.",
    photo: patiencePhoto
  },
  {
    name: "Glenn J.",
    title: "Logistics Manager",
    rating: 5,
    text: "EAP Finance has been a game-changer for my investments. Their sharp market analysis and forward-thinking approach to risk management have really paid off, giving me a newfound confidence in my financial future",
    photo: glennPhoto
  },
];

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToNext = () => {
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrev = () => {
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setIsTransitioning(true);
    setCurrentIndex(index);
  };

  const handleTransitionEnd = () => {
    setIsTransitioning(false);
  };

  return (
    <div className="w-full py-16 bg-gray-50/50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl font-bold text-center text-gray-900 mb-4">
          Client Endorsements
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Gain insight from clients who have partnered with us
        </p>
        
        <div className="relative overflow-hidden">
          {/* Navigation Arrows */}
          <button 
            onClick={goToPrev}
            className="absolute left-0 md:left-4 top-1/2 -translate-y-1/2 z-10 bg-white p-3 rounded-full shadow-lg hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-custom_blue hover:scale-110"
            aria-label="Previous testimonial"
          >
            <i className="fas fa-chevron-left text-gray-700 text-lg"></i>
          </button>
          
          <button 
            onClick={goToNext}
            className="absolute right-0 md:right-4 top-1/2 -translate-y-1/2 z-10 bg-white p-3 rounded-full shadow-lg hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-custom_blue hover:scale-110"
            aria-label="Next testimonial"
          >
            <i className="fas fa-chevron-right text-gray-700 text-lg"></i>
          </button>

          {/* Testimonial Cards */}
          <div 
            className={`flex transition-transform duration-500 ease-in-out`}
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            onTransitionEnd={handleTransitionEnd}
          >
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="min-w-full px-4 sm:px-8"
              >
                <div className="bg-white p-8 rounded-xl shadow-xl border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
                  <div className="flex flex-col items-center mb-6">
                    {/* Profile Photo with elegant border */}
                    <div className="relative mb-6">
                      <img 
                        src={testimonial.photo} 
                        alt={testimonial.name}
                        className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-4 border-white shadow-lg"
                      />
                      {/* Decorative element */}
                      <div className="absolute -bottom-2 -right-2 bg-gray-900 text-white rounded-full p-2">
                        <i className="fas fa-quote-left text-xs"></i>
                      </div>
                    </div>
                    
                    <div className="flex justify-center space-x-1 mb-4">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`fas fa-star text-lg ${
                            i < testimonial.rating
                              ? "text-yellow-500"
                              : "text-gray-900"
                          }`}
                        ></i>
                      ))}
                    </div>
                    
                    <blockquote className="text-gray-700 text-center text-sm sm:text-base italic mb-6 relative px-6 py-2">
                      <i className="fas fa-quote-left text-gray-200 text-3xl absolute -top-4 -left-2"></i>
                      {testimonial.text}
                      <i className="fas fa-quote-right text-gray-200 text-3xl absolute -bottom-4 -right-2"></i>
                    </blockquote>
                  </div>
                  
                  <div className="text-center">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {testimonial.name}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center my-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex 
                    ? "bg-[#000] scale-125" 
                    : "bg-[#000] hover:bg-gray-400"
                }`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;